import { css } from 'lit';
import scss from '@/utils/scssAsCss';

export default css`
notification-banner {
  position: fixed;
  top: var(--header-height);
  width: 100%;
}

:host {
  z-index: 2526;
  position: sticky;
  top: 0;
  border-bottom: 1px solid rgb(var(--brand-primary));
}
@media print {
  :host {
    display: none;
  }
}

:host([view=event]) {
  position: initial;
}

.signout-menu {
  width: auto;
}

.signout-menu::part(bg) {
  background-color: rgb(var(--brand-primary-dark));
}

.signout-menu::part(img) {
  width: 36px;
  height: 36px;
}

.signout-menu::part(label) {
  color: rgb(var(--brand-secondary));
}

.signout-menu::part(caret) {
  fill: rgb(var(--brand-secondary));
}

#topbar {
  box-sizing: border-box;
  z-index: 1024;
  height: var(--header-height);
  left: 0px;
  color: rgb(var(--brand-grey-dimmer));
  background-color: rgb(var(--brand-primary));
  background-image: var(--bg-image);
  background-size: var(--bg-size);
  border-bottom: 1px solid rgb(var(--brand-grey));
}
@media (max-width: 999px) {
  #topbar {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    height: 70px;
  }
}
#page-title {
  flex: 1 1 100%;
  width: 100%;
  line-height: 70px;
  font-weight: bold;
  letter-spacing: 2px;
  text-align: center;
  color: rgb(var(--brand-secondary));
  display: none;
}
@media (max-width: 999px) {
  #page-title {
    display: block;
  }
}

#logo-link {
  height: 100%;
  float: left;
}
@media (max-width: 999px) {
  #logo-link {
    flex: 0 0 auto;
    float: none;
  }
}
#logo-link a {
  display: block;
  padding: calc(var(--ggutter) / 2) var(--ggutter);
}
@media (max-width: 999px) {
  #logo-link a {
    padding: 12px;
  }
}
#logo-link a img {
  object-fit: fill;
}
@media (max-width: 999px) {
  #logo-link a img {
    height: 48px;
    max-height: 48px;
  }
}

#menu-container {
  width: 100%;
}
@media (max-width: 999px) {
  #menu-container {
    flex: 0 0 auto;
    width: auto;
    float: none;
  }
}
#menu-container > summary {
  position: absolute;
  z-index: 1050;
  top: 18px;
  right: 18px;
  display: none;
  width: 36px;
  height: 36px;
  background: url("/img/icon-hamburger-fill.svg") no-repeat center center;
  background-size: 36px;
}
@media (max-width: 999px) {
  #menu-container > summary {
    display: block;
    position: static;
    padding: 0px 18px;
    height: 100%;
  }
}
#menu-container > summary > span {
  display: none;
}
#menu-container[open] > summary {
  background-image: url("/img/icon-hamburger-fill - gold.svg");
}
#menu-container > .details-content {
  z-index: 1050;
  height: inherit;
}
#menu-container > .details-content ul {
  height: var(--header-height);
}
#menu-container > .details-content ul li {
  height: 100%;
}
#menu-container > .details-content ul li a {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding: 0px var(--ggutter);
  text-decoration: inherit;
  color: inherit;
}
#menu-container > .details-content ul li a > div {
  flex: 0 0 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  margin-top: calc(var(--ggutter) * 0.75);
  border-radius: 50%;
  background-color: rgb(var(--brand-grey-dim));
}
#menu-container > .details-content ul li a > div img {
  display: block;
}
#menu-container > .details-content ul li a span {
  flex: 0 1 100%;
  margin-top: 4px;
}
#menu-container > .details-content ul li.active a {
  background-color: rgba(var(--brand-primary-darkest), 0.5);
  color: rgb(var(--brand-secondary));
}
#menu-container > .details-content ul li.active a > div {
  background-color: rgb(var(--brand-secondary));
}
#menu-container > .details-content ul.left-links {
  float: left;
}
#menu-container > .details-content ul.left-links li {
  float: left;
  margin-left: var(--ggutter);
}
#menu-container > .details-content ul.right-links {
  float: right;
}
#menu-container > .details-content ul.right-links li {
  float: right;
  /* margin-right: calc(var(--ggutter) * 2); */
  position: relative;
}
#signout-link {
  position: relative;
}
#signout-link > div {
  background-color: rgb(var(--brand-primary-dark)) !important;
  border-radius: 50% !important;
  padding: 0px !important;
}
#signout-link > span {
  color: rgb(var(--brand-secondary));
}

@media (max-width: 999px) {
  #menu-container > .details-content {
    position: absolute;
    z-index: 10;
    top: 70px;
    left: 0px;
    width: 100%;
    background-color: rgb(var(--brand-primary));
    max-height: 60vh;
    overflow-y: scroll;
  }
  #menu-container > .details-content ul {
    height: auto;
  }
  #menu-container > .details-content ul.left-links, #menu-container > .details-content ul.right-links {
    float: none;
    clear: both;
  }
  #menu-container > .details-content ul.left-links li, #menu-container > .details-content ul.right-links li {
    display: block;
    width: 100%;
    float: none;
    clear: both;
    margin: 0px;
    text-align: unset;
  }
  #menu-container > .details-content ul.left-links li a, #menu-container > .details-content ul.right-links li a {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px 0px var(--ggutter) var(--ggutter);
  }
  #menu-container > .details-content ul.left-links li a > div > img, #menu-container > .details-content ul.right-links li a > div > img {
    display: inline-block;
  }
  #menu-container > .details-content ul.left-links li a span, #menu-container > .details-content ul.right-links li a span {
    margin-top: 10px;
    display: inline-block;
    text-indent: 1em;
  }
}
`;
